import { ScreenBase } from "@frui.ts/screens";

export default class EshopViewModel extends ScreenBase {
  constructor() {
    super();
    this.navigationName = "k-prodeji";
    this.name = "K prodeji";
  }
}
